import React from 'react'
import { isArray, isFunction, isString, reduce } from 'lodash'

export default function GQLHOC (func = () => ({})) {
  return (WrappedComponent) => {
    return function (props) {

      return (
        <WrappedComponent {...{
          ...props,
          ...reduce(func(props), (result, q, key) => {

            if (isString(q)) {
              return {
                ...result,
                [key]: q
              }
            }

            if (isArray(q) && isFunction(q[0])) {
              return {
                ...result,
                [key]: q[0],
                [key + '_meta']: q[1]
              }
            }
            return {
              ...result,
              [key]: {
                ...q,
                ...q?.data || {}
              }
            }
          }, {}),
        }} />
      )

    }
  }
}
